<template>
  <w-icon-wrapper
    :width='24'
    :height='26.4'
    icon-name='work-nav-contacts-icon'
    view-box='0 0 24 26.4'
  >
    <path
      id="_12_Kontakte_Icon"
      data-name="12_Kontakte_Icon"
      d="M82.4-893.6V-896h19.2v2.4Zm0-24V-920h19.2v2.4Zm9.6,12a3.472,3.472,0,0,0,2.55-1.05,3.472,3.472,0,0,0,1.05-2.55,3.472,3.472,0,0,0-1.05-2.55A3.472,3.472,0,0,0,92-912.8a3.472,3.472,0,0,0-2.55,1.05,3.472,3.472,0,0,0-1.05,2.55,3.472,3.472,0,0,0,1.05,2.55A3.472,3.472,0,0,0,92-905.6Zm-9.6,8.4a2.311,2.311,0,0,1-1.695-.705A2.311,2.311,0,0,1,80-899.6V-914a2.311,2.311,0,0,1,.705-1.7A2.311,2.311,0,0,1,82.4-916.4h19.2a2.311,2.311,0,0,1,1.695.705A2.311,2.311,0,0,1,104-914v14.4a2.311,2.311,0,0,1-.705,1.7,2.311,2.311,0,0,1-1.695.705Zm2.1-2.4a9.732,9.732,0,0,1,3.27-2.64A9.325,9.325,0,0,1,92-903.2a9.325,9.325,0,0,1,4.23.96,9.732,9.732,0,0,1,3.27,2.64h2.1V-914H82.4v14.4Zm3.54,0h7.92a6.617,6.617,0,0,0-1.875-.9A7.25,7.25,0,0,0,92-900.8a7.25,7.25,0,0,0-2.085.3A6.617,6.617,0,0,0,88.04-899.6ZM92-908a1.161,1.161,0,0,1-.855-.345,1.161,1.161,0,0,1-.345-.855,1.161,1.161,0,0,1,.345-.855A1.161,1.161,0,0,1,92-910.4a1.161,1.161,0,0,1,.855.345,1.161,1.161,0,0,1,.345.855,1.161,1.161,0,0,1-.345.855A1.161,1.161,0,0,1,92-908ZM92-906.8Z"
      transform="translate(-80 920)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavContacts' };
</script>

